export function checkMailValidity(email: HTMLInputElement): boolean {
  let isMailValid;

  if (email.checkValidity()) {
    const regExp = /\S+@\S+\.\S+/;
    const noValidationAlert: NodeListOf<Element> = document.querySelectorAll('.js-emailValidation');
    if (!regExp.test(email.value)) {
      noValidationAlert.forEach( (alert) => {
        alert.classList.add('emailValidation--notValid');
      });
      email.classList.add('input--notValid');
      isMailValid = false;
    } else {
      noValidationAlert.forEach( (alert) => {
        alert.classList.remove('emailValidation--notValid');
      });
      isMailValid = true;
    }
  }

  return isMailValid;
}
